import { useTheme } from '@mui/material';
import React from 'react';

export const PinIcon = ({ classNamePath }: { classNamePath?: string }) => {
  const theme = useTheme();
  return (
    <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        className={classNamePath}
        d="M4.32867 6.856C4.19677 6.93338 4.08438 7.03999 4.00014 7.16761C3.91589 7.29524 3.86204 7.44049 3.84273 7.59219C3.82341 7.74388 3.83914 7.89799 3.88871 8.04266C3.93828 8.18732 4.02037 8.31869 4.12867 8.42666L9.604 13.902C9.71197 14.0103 9.84334 14.0924 9.98801 14.1419C10.1327 14.1915 10.2868 14.2073 10.4385 14.1879C10.5902 14.1686 10.7354 14.1148 10.863 14.0305C10.9907 13.9463 11.0973 13.8339 11.1747 13.702C11.8232 12.5862 12.0166 11.2634 11.7147 10.0087L16.068 7.23866C16.1944 7.15816 16.3012 7.05026 16.3803 6.92296C16.4594 6.79565 16.5089 6.65218 16.5251 6.50317C16.5413 6.35416 16.5238 6.20341 16.4738 6.06208C16.4239 5.92075 16.3429 5.79245 16.2367 5.68666L12.3427 1.79266C12.2368 1.68681 12.1084 1.6061 11.9671 1.55649C11.8259 1.50687 11.6752 1.48962 11.5264 1.506C11.3776 1.52238 11.2343 1.57198 11.1072 1.65114C10.9801 1.73029 10.8724 1.83698 10.792 1.96333L8.022 6.31599C6.76727 6.01404 5.44443 6.20745 4.32867 6.856Z"
        fill={theme.palette.widget['icon-02']}
        stroke={theme.palette.widget['icon-02']}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className={classNamePath}
        d="M6.83472 11.1646L1.49939 16.4999"
        stroke={theme.palette.widget['icon-02']}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UnpinIcon = ({ classNamePath }: { classNamePath?: string }) => {
  const theme = useTheme();
  return (
    <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        className={classNamePath}
        d="M4.32867 6.856C4.19677 6.93338 4.08438 7.03999 4.00014 7.16761C3.91589 7.29524 3.86204 7.44049 3.84273 7.59218C3.82341 7.74388 3.83914 7.89799 3.88871 8.04266C3.93828 8.18732 4.02037 8.31869 4.12867 8.42666L9.604 13.902C9.71197 14.0103 9.84334 14.0924 9.98801 14.1419C10.1327 14.1915 10.2868 14.2073 10.4385 14.1879C10.5902 14.1686 10.7354 14.1148 10.863 14.0305C10.9907 13.9463 11.0973 13.8339 11.1747 13.702C11.8232 12.5862 12.0166 11.2634 11.7147 10.0087L16.068 7.23866C16.1944 7.15816 16.3012 7.05026 16.3803 6.92296C16.4594 6.79565 16.5089 6.65218 16.5251 6.50317C16.5413 6.35416 16.5238 6.20341 16.4738 6.06208C16.4239 5.92075 16.3429 5.79245 16.2367 5.68666L12.3427 1.79266C12.2368 1.68681 12.1084 1.6061 11.9671 1.55649C11.8259 1.50687 11.6752 1.48962 11.5264 1.506C11.3776 1.52238 11.2343 1.57198 11.1072 1.65114C10.9801 1.73029 10.8724 1.83698 10.792 1.96333L8.022 6.31599C6.76727 6.01404 5.44443 6.20745 4.32867 6.856V6.856Z"
        stroke={theme.palette.widget['icon-02']}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className={classNamePath}
        d="M6.83472 11.1646L1.49939 16.4999"
        stroke={theme.palette.widget['icon-02']}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
